

export class SolicitudAtestFitoTextoViewModel {

    constructor() {

    }

    public Id: number;
    public FechaCreacion: Date;
    public IdEstado: number = 0;
    public IdEstadoDescripcion: string = '';
    public IdTipoSolicitud: number = 0;
    public IdTipoSolicitudDescripcion: string;
    public CodigoTipoSolicitud: string;
    public RefAtestFito: string;
    public TextoAtestFito: string;
    public TextoAtestFitoUsuarioCaAc: string;
}






